"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorOnboardingV2FlowStep = void 0;
var AvenAdvisorOnboardingV2FlowStep;
(function (AvenAdvisorOnboardingV2FlowStep) {
    AvenAdvisorOnboardingV2FlowStep["LANDING_PAGE"] = "landing_page";
    AvenAdvisorOnboardingV2FlowStep["OTP_VERIFICATION"] = "otp_verification";
    AvenAdvisorOnboardingV2FlowStep["SSN_LAST_4"] = "ssn_last_4";
    AvenAdvisorOnboardingV2FlowStep["PREFILLED_PERSONAL_INFO"] = "prefilled_personal_info";
    AvenAdvisorOnboardingV2FlowStep["TAX_RETURN_ADDRESS"] = "tax_return_address";
    AvenAdvisorOnboardingV2FlowStep["KNOWLEDGE_BASED_AUTHENTICATION"] = "knowledge_based_authentication";
    AvenAdvisorOnboardingV2FlowStep["STATED_INCOME_AND_IRS_CONSENT"] = "stated_income_and_irs_consent";
    AvenAdvisorOnboardingV2FlowStep["REVOLVING_CREDIT_CARD_BALANCE_QUIZ"] = "revolving_credit_card_balance_quiz";
    AvenAdvisorOnboardingV2FlowStep["MORTGAGE_APR_QUIZ"] = "mortgage_apr_quiz";
    AvenAdvisorOnboardingV2FlowStep["HELOC_APR_QUIZ"] = "heloc_apr_quiz";
    AvenAdvisorOnboardingV2FlowStep["EMAIL_AND_PASSWORD_SETUP"] = "email_and_password_setup";
})(AvenAdvisorOnboardingV2FlowStep || (exports.AvenAdvisorOnboardingV2FlowStep = AvenAdvisorOnboardingV2FlowStep = {}));
